module.exports = __webpack_public_path__ + "img/pgd_a_00011.d64df328.png";